// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1q0VU","icon":"SortAdornment_icon__iiCca","up":"SortAdornment_up__2Nvi-","down":"SortAdornment_down__2M8_w","active":"SortAdornment_active__23MQn"};